
const limitJudge = (str1,str2='*:*:*') =>{
    let signList =  JSON.parse(localStorage.getItem('permissions'))

    return signList.includes(str1.trim()) || signList.includes(str2.trim());
}
export default limitJudge ;